module.exports = __webpack_public_path__ + "img/pause.c080757c.png";